/* Müşteri yorumları (Tur 41). Judge.me yorumları tarayıcıda çizdiği için burada işlenir, sıralama ve sayfa değişince de tekrar çalışır.
   - Varsayılan sıralama: en yüksek puan (müşteri açılır listeden değiştirebilir). Judge.me sıralama değişince sayfayı yorumlara
     kaydırdığı için yalnızca bu ilk otomatik sıralamada kaydırma engellenir; müşterinin kendi seçimi etkilenmez.
   - Gerçek isim: "Serhat Kotan" -> "S*** K***". İsimsiz yorum: genel "Palmiye Gurme müşterisi" etiketi;
     olmayan bir kişiyi ima eden isim ya da harf üretilmez.
   - Özet kısa: "5 üzerinden 5.00" -> "5.0", "2 değerlendirmeye dayanmaktadır" -> "2 değerlendirme".
   Başka bir tema betiği "Anonymous" yazısını sonradan "Anonim" yaptığı için işaretleme kullanılmaz; her değişiklikte metne bakılır. */
(function () {
  var LABEL = 'Palmiye Gurme müşterisi';
  var ANON = /^(anonymous|anonim|anonim müşteri)?$/i;
  var sorted = false;

  function mask(name) {
    return name.split(/\s+/).filter(Boolean).map(function (word) {
      return word.charAt(0).toLocaleUpperCase('tr') + '***';
    }).join(' ');
  }

  function applyNames() {
    document.querySelectorAll('.jdgm-rev__author').forEach(function (el) {
      var name = el.textContent.trim();
      if (name === LABEL || name.indexOf('***') > -1) return;
      el.textContent = ANON.test(name) ? LABEL : mask(name);
    });
  }

  function applySummary() {
    document.querySelectorAll('.jdgm-rev-widg__summary-average').forEach(function (el) {
      var nums = el.textContent.match(/\d+(?:[.,]\d+)?/g);
      if (!nums || nums.length < 2) return;
      el.textContent = parseFloat(nums[nums.length - 1].replace(',', '.')).toFixed(1);
    });
    document.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(function (el) {
      var m = el.textContent.trim().match(/^(\d+)\s+\S*erlendirmeye\b/i);
      if (m) el.textContent = m[1] + ' değerlendirme';
    });
  }

  function applySort() {
    if (sorted) return;
    var select = document.querySelector('.jdgm-sort-dropdown');
    if (!select || !document.querySelector('.jdgm-rev')) return;
    sorted = true;
    if (select.value !== 'most-recent') return;
    var jq = window.jdgm && window.jdgm.$;
    var animate = jq && jq.fn.animate;
    if (animate) {
      jq.fn.animate = function (props) {
        if (props && Object.prototype.hasOwnProperty.call(props, 'scrollTop')) return this;
        return animate.apply(this, arguments);
      };
      setTimeout(function () { jq.fn.animate = animate; }, 3000);
    } else {
      // Judge.me jQuery'si yoksa kaydırma engellenemez; sayfayı kaydırmaktansa sıralama değiştirilmez
      return;
    }
    select.value = 'highest-rating';
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function run() {
    applyNames();
    applySummary();
    applySort();
  }

  function start() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
